var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12a9 9 0 019-9h10a9 9 0 019 9v2a9 9 0 01-9 9H5a5 5 0 01-5-5v-6z",
    fill: "#FFE600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12a9 9 0 019-9h10a9 9 0 019 9v2a9 9 0 01-9 9H5a5 5 0 01-5-5v-6z",
    fill: "#FFFC00",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.982 17H8.294l3.072-8.727h1.952L16.395 17h-1.688l-2.33-6.938h-.069L9.982 17zm.055-3.422h4.602v1.27h-4.602v-1.27zm9.088-5.305V17h-1.58V8.273h1.58z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.715.578c.236-.775 1.334-.775 1.57 0l.189.62A5 5 0 0029.8 4.527l.621.19c.775.235.775 1.333 0 1.568l-.62.19A5 5 0 0026.473 9.8l-.19.621c-.235.775-1.333.775-1.569 0l-.189-.62A5 5 0 0021.2 6.473l-.621-.19c-.775-.235-.775-1.333 0-1.568l.62-.19A5 5 0 0024.527 1.2l.19-.621z",
    fill: "#1EF0AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.715.578c.236-.775 1.334-.775 1.57 0l.189.62A5 5 0 0029.8 4.527l.621.19c.775.235.775 1.333 0 1.568l-.62.19A5 5 0 0026.473 9.8l-.19.621c-.235.775-1.333.775-1.569 0l-.189-.62A5 5 0 0021.2 6.473l-.621-.19c-.775-.235-.775-1.333 0-1.568l.62-.19A5 5 0 0024.527 1.2l.19-.621z",
    fill: "url(#prefix__paint0_linear_685_12197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_685_12197",
    x1: 21.214,
    y1: 9.786,
    x2: 29.993,
    y2: 0.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#277EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#E64BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconmin);
export default __webpack_public_path__ + "static/media/ai-icon.min.935d47902b1b8450a10862bc9b536c30.svg";
export { ForwardRef as ReactComponent };